import type { SvgIconProps } from './types/props.ts'

export const RocketUpIcon = (props: SvgIconProps) => {
  return (
    <svg
      {...props}
      viewBox="0 0 164 554"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Rocket Up Icon"
      role="img"
    >
      <rect
        x="81"
        y="435"
        width="166"
        height="2.00001"
        rx="1"
        transform="rotate(-90 81 435)"
        fill="#15D17C"
      />
      <rect
        x="63"
        y="394"
        width="70"
        height="2"
        rx="1"
        transform="rotate(-90 63 394)"
        fill="#15D17C"
      />
      <rect
        opacity="0.2"
        x="73"
        y="383"
        width="41"
        height="2"
        rx="1"
        transform="rotate(-90 73 383)"
        fill="#15D17C"
      />
      <rect
        opacity="0.2"
        x="108"
        y="503"
        width="126"
        height="2"
        rx="1"
        transform="rotate(-90 108 503)"
        fill="#15D17C"
      />
      <rect
        opacity="0.2"
        x="90"
        y="340"
        width="37"
        height="2"
        rx="1"
        transform="rotate(-90 90 340)"
        fill="#15D17C"
      />
      <rect
        opacity="0.2"
        x="72"
        y="550"
        width="126"
        height="2"
        rx="1"
        transform="rotate(-90 72 550)"
        fill="#15D17C"
      />
      <rect
        x="99"
        y="358"
        width="70"
        height="2"
        rx="1"
        transform="rotate(-90 99 358)"
        fill="#15D17C"
      />
      <rect
        x="117"
        y="394"
        width="36"
        height="2"
        rx="1"
        transform="rotate(-90 117 394)"
        fill="#15D17C"
      />
      <rect
        x="46"
        y="403"
        width="20"
        height="2"
        rx="1"
        transform="rotate(-90 46 403)"
        fill="#15D17C"
      />
      <rect
        x="63"
        y="440"
        width="20"
        height="2"
        rx="1"
        transform="rotate(-90 63 440)"
        fill="#15D17C"
      />
      <rect
        x="99"
        y="413"
        width="21"
        height="2"
        rx="1"
        transform="rotate(-90 99 413)"
        fill="#15D17C"
      />
      <rect
        opacity="0.2"
        x="81"
        y="242"
        width="116"
        height="2.00001"
        rx="1"
        transform="rotate(-90 81 242)"
        fill="#15D17C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M81.7135 44.7079C81.9004 44.652 82.0996 44.652 82.2865 44.7079C86.1649 45.8676 91.3449 49.0864 94.4157 54.9943C97.5043 60.9365 98.3825 69.4473 93.9112 81.0262C93.8073 81.2954 93.5922 81.5065 93.3212 81.6054C93.0502 81.7043 92.7497 81.6814 92.4969 81.5425C91.3347 80.9041 87.4504 79.4797 82 79.4797C76.5496 79.4797 72.6653 80.9041 71.5031 81.5425C71.2503 81.6814 70.9498 81.7043 70.6788 81.6054C70.4078 81.5065 70.1927 81.2954 70.0888 81.0262C65.6176 69.4473 66.4957 60.9365 69.5843 54.9943C72.6551 49.0864 77.8351 45.8676 81.7135 44.7079ZM71.5788 79.3048C73.5686 78.4911 77.2665 77.4797 82 77.4797C86.7335 77.4797 90.4314 78.4911 92.4212 79.3048C96.3002 68.6613 95.3246 61.0795 92.6411 55.9167C89.933 50.7066 85.4117 47.8146 82 46.7132C78.5883 47.8146 74.067 50.7066 71.3589 55.9167C68.6754 61.0795 67.6998 68.6613 71.5788 79.3048Z"
        fill="#15D17C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M77.993 57.9927C79.0557 56.93 80.4971 56.333 81.9999 56.333C83.5028 56.333 84.9442 56.93 86.0069 57.9927C87.0696 59.0554 87.6666 60.4968 87.6666 61.9997C87.6666 63.5026 87.0696 64.9439 86.0069 66.0066C84.9442 67.0693 83.5028 67.6663 81.9999 67.6663C80.4971 67.6663 79.0557 67.0693 77.993 66.0066C76.9303 64.9439 76.3333 63.5026 76.3333 61.9997C76.3333 60.4968 76.9303 59.0554 77.993 57.9927ZM81.9999 58.333C81.0275 58.333 80.0949 58.7193 79.4072 59.4069C78.7196 60.0946 78.3333 61.0272 78.3333 61.9997C78.3333 62.9721 78.7196 63.9048 79.4072 64.5924C80.0949 65.28 81.0275 65.6663 81.9999 65.6663C82.9724 65.6663 83.905 65.28 84.5927 64.5924C85.2803 63.9048 85.6666 62.9721 85.6666 61.9997C85.6666 61.0272 85.2803 60.0946 84.5927 59.4069C83.905 58.7193 82.9724 58.333 81.9999 58.333ZM68.9732 66.4364C69.1001 66.9739 68.7673 67.5126 68.2299 67.6396C63.4033 68.7798 61.2998 71.9516 60.3679 74.8988C59.8971 76.3877 59.7306 77.8137 59.6835 78.8724C59.6833 78.8757 59.6832 78.8789 59.6831 78.882C62.6342 77.2825 66.1776 76.5731 69.0748 76.3059C69.6247 76.2552 70.1117 76.6599 70.1624 77.2098C70.2131 77.7598 69.8084 78.2467 69.2585 78.2974C65.958 78.6019 62.0505 79.491 59.2959 81.4774C59.0067 81.6859 58.6284 81.7248 58.303 81.5793C57.9775 81.4339 57.7541 81.1262 57.7165 80.7717L58.7109 80.6663C57.7165 80.7717 57.7165 80.7712 57.7164 80.7707L57.7163 80.7694L57.7159 80.766L57.7149 80.7561L57.7119 80.7238C57.7094 80.6968 57.7062 80.6591 57.7026 80.6112C57.6954 80.5154 57.6868 80.3789 57.6798 80.2067C57.666 79.8627 57.6592 79.3746 57.6855 78.7835C57.7379 77.6051 57.9232 75.9967 58.461 74.2959C59.5462 70.8637 62.0873 67.0356 67.77 65.6931C68.3075 65.5662 68.8462 65.8989 68.9732 66.4364ZM95.0267 66.4364C95.1537 65.8989 95.6924 65.5662 96.2299 65.6931C101.913 67.0356 104.454 70.8637 105.539 74.2959C106.077 75.9967 106.262 77.6051 106.314 78.7835C106.341 79.3746 106.334 79.8627 106.32 80.2067C106.313 80.3789 106.304 80.5154 106.297 80.6112C106.294 80.6591 106.29 80.6968 106.288 80.7238L106.285 80.7561L106.284 80.766L106.284 80.7694L106.283 80.7707C106.283 80.7712 106.283 80.7717 105.289 80.6663L106.283 80.7717C106.246 81.1262 106.022 81.4339 105.697 81.5793C105.371 81.7248 104.993 81.6859 104.704 81.4774C101.949 79.491 98.0419 78.6019 94.7414 78.2974C94.1915 78.2467 93.7868 77.7598 93.8375 77.2098C93.8882 76.6599 94.3752 76.2552 94.9251 76.3059C97.8223 76.5731 101.366 77.2825 104.317 78.882C104.317 78.8789 104.317 78.8757 104.316 78.8724C104.269 77.8137 104.103 76.3877 103.632 74.8988C102.7 71.9516 100.597 68.7798 95.77 67.6396C95.2326 67.5126 94.8998 66.9739 95.0267 66.4364ZM77.153 85.1685C77.153 85.1687 77.153 85.1682 77.153 85.1685L77.1538 85.1729L77.1606 85.209C77.1672 85.2432 77.1781 85.2971 77.1939 85.3682C77.2257 85.5105 77.2771 85.7207 77.3535 85.979C77.507 86.498 77.7576 87.1982 78.1441 87.927C78.8926 89.3382 80.0922 90.756 81.9999 91.2994C83.9077 90.756 85.1073 89.3382 85.8558 87.927C86.2423 87.1982 86.4929 86.498 86.6464 85.979C86.7228 85.7207 86.7742 85.5105 86.806 85.3682C86.8218 85.2971 86.8327 85.2432 86.8393 85.209L86.8461 85.1729L86.8469 85.1685C86.9381 84.6241 87.4533 84.2558 87.9978 84.3466C88.5426 84.4375 88.9105 84.9528 88.8197 85.4975L87.8333 85.333C88.8197 85.4975 88.8197 85.4971 88.8197 85.4975L88.819 85.5016L88.8179 85.5078L88.8146 85.5266C88.8118 85.5419 88.808 85.5626 88.803 85.5886C88.793 85.6404 88.7782 85.713 88.758 85.8037C88.7175 85.985 88.655 86.2395 88.5642 86.5464C88.3834 87.1576 88.087 87.9886 87.6227 88.8641C86.6997 90.6044 85.0497 92.6294 82.2334 93.3054C82.0799 93.3422 81.92 93.3422 81.7665 93.3054C78.9502 92.6294 77.3002 90.6044 76.3772 88.8641C75.9129 87.9886 75.6165 87.1576 75.4357 86.5464C75.3449 86.2395 75.2824 85.985 75.2419 85.8037C75.2217 85.713 75.2069 85.6404 75.1969 85.5886C75.1919 85.5626 75.1881 85.5419 75.1853 85.5266L75.182 85.5078L75.1809 85.5016L75.1805 85.4993C75.1805 85.4989 75.1802 85.4975 76.1666 85.333L75.1802 85.4975C75.0894 84.9528 75.4573 84.4375 76.0021 84.3466C76.5462 84.2559 77.061 84.6229 77.1527 85.1667C77.1527 85.1669 77.1527 85.1665 77.1527 85.1667C77.1527 85.1668 77.153 85.1683 77.153 85.1685Z"
        fill="#15D17C"
      />
    </svg>
  )
}
